import _ from 'lodash';
import {GeneralService} from "../../../services/generalService";
import {RouteService} from "../../../services/routeService";
import {NotificationService} from "../../../services/notificationService";
import {DICTIONARY} from "../../../dictionary";
import {Component, OnInit} from "@angular/core";
import util from "util";
import {LookAndFeelService} from "../../../services/lookAndFeelService";

@Component({
	selector: 'partner-usage-component',
	templateUrl: './partner-usage.component.html',
})
export class PartnerUsageComponent implements OnInit {
    constructor(public gs:GeneralService,
				private lfs:LookAndFeelService,
				private rs:RouteService,
				private ns:NotificationService) {
    }

    usage;
    inboundUsersMeterChartOptions;
    inboundPlansTypesChartOptions;
    inboundTopPlanUsageChartOptions;
    outboundUsersMeterChartOptions;
    outboundPlansTypesChartOptions;
    outboundTopPlanUsageChartOptions;
    getUsageDataInProcess = false;
	generateReportPopup;
    partnerInfo;
    dic = DICTIONARY;
	Math = Math;

	curSharedUser;
	currentAdminObj;
	updateAdminPlanPopup = false;
	isPartnerAdmin = true;
	expandMethods = {
		oneMonth: {display: 'one month', value: 'month'},
		oneYear: {display: 'one year', value: 'year'},
		twoYears: {display: '2 years', value: '2years'},
		threeYears: {display: '3 years', value: '3years'},
	}
	addActiveAdminPopup;
	adminExpirationDateMaxString;
	userManagementLoaded;
	setUserAsAdminInProcess;
	adminExpirationDateMinString;

	ngOnInit() {
		this.getPartnerUsage();
	}

    getPartnerUsage = () => {
        this.getUsageDataInProcess = true;

        this.rs.getPartnerStats().then((response) => {
            this.usage = response;
			this.usage.general.forEach((generalObj) => {
				if (generalObj.email === 'Your Plan') {
					generalObj.plan_sub_type_display = 'NFR';
					generalObj.hideActions = true;
				} else {
					this.changePlanSubTypeDisplay(generalObj);
				}
			});
            this.usage.outbound.plansUsage.data = this.usage.outbound.plansUsage.data.slice(0, 10);
            this.usage.outbound.plansUsage.labels = this.usage.outbound.plansUsage.labels.slice(0, 10);

            this.usage.inbound.plansUsage.data = this.usage.inbound.plansUsage.data.slice(0, 10);
            this.usage.inbound.plansUsage.labels = this.usage.inbound.plansUsage.labels.slice(0, 10);

            // inbound users usage meter chart
            const inboundUsedUsersRatio = Math.round(this.usage.inbound.used_users / this.usage.inbound.allowed_users * 100);
            const inboundUsersBgColor = inboundUsedUsersRatio > 90 ? '#d9355a' : inboundUsedUsersRatio > 70 ? '#e6cd4f' : '#006400'; // (#006400 = darkgreen)
            this.inboundUsersMeterChartOptions = {
                series: [inboundUsedUsersRatio],
                chart: {
                    type: 'radialBar',
                    width: '220'
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            background: "#e7e7e7",
                            strokeWidth: '97%',
                            margin: 5, // margin is in pixels
                        },
                        dataLabels: {
                            name: {
                                show: false
                            },
                            value: {
                                offsetY: -12,
                                fontSize: '100%'
                            }
                        }
                    }
                },
                colors: [inboundUsersBgColor],

                labels: ['Licenses'],
            };

            this.inboundPlansTypesChartOptions = {
                series: this.usage.inbound.plansStats.plans.data,
                chart: {
                    type: 'donut',
                    height: '100%'
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '52%',
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, opt) {
                        return opt.w.globals.series[opt.seriesIndex];
                    }
                },
                colors: [ '#ff9f67', '#fad07d', '#77a380', '#8177a3'],
                labels: this.usage.inbound.plansStats.plans.labels
            };

            this.inboundTopPlanUsageChartOptions = {
                series: [{
                    name: 'Licenses',
                    data: this.usage.inbound.plansUsage.data
                }],
                chart: {
                    type: 'bar',
                    height: '100%',
                    toolbar: {
                        show: false
                    },
                },
                colors: [
                    this.lfs.color
                ],
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                        barHeight: this.gs.getOptimalBarWidth(this.usage.inbound.plansUsage.labels.length) + '%',
                    }
                },
                dataLabels: {
                    total: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                            fontSize: '13px',
                            fontWeight: 900
                        }
                    }
                },
                xaxis: {
                    categories: this.usage.inbound.plansUsage.labels,
                },
            };

            // inbound users usage meter chart
            const outboundUsedUsersRatio = Math.round(this.usage.outbound.used_users / this.usage.outbound.allowed_users * 100);
            const outboundUsersBgColor = outboundUsedUsersRatio > 90 ? '#d9355a' : outboundUsedUsersRatio > 70 ? '#e6cd4f' : '#006400'; // (#006400 = darkgreen)
            this.outboundUsersMeterChartOptions = {
                series: [outboundUsedUsersRatio],
                chart: {
                    type: 'radialBar',
                    width: '220'
                },
                plotOptions: {
                    radialBar: {
                        startAngle: -90,
                        endAngle: 90,
                        track: {
                            background: "#e7e7e7",
                            strokeWidth: '97%',
                            margin: 5, // margin is in pixels
                        },
                        dataLabels: {
                            name: {
                                show: false
                            },
                            value: {
                                offsetY: -12,
                                fontSize: '100%'
                            }
                        }
                    }
                },
                colors: [outboundUsersBgColor],

                labels: ['Licenses'],
            };

            this.outboundPlansTypesChartOptions = {
                series: this.usage.outbound.plansStats.plans.data,
                chart: {
                    type: 'donut',
                    height: '100%'
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '52%',
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val, opt) {
                        return opt.w.globals.series[opt.seriesIndex];
                    }
                },
                colors: [ '#ff9f67', '#fad07d', '#77a380', '#8177a3'],
                labels: this.usage.outbound.plansStats.plans.labels
            };

            this.outboundTopPlanUsageChartOptions = {
                series: [{
                    name: 'Licenses',
                    data: this.usage.outbound.plansUsage.data
                }],
                chart: {
                    type: 'bar',
                    height: '100%',
                    toolbar: {
                        show: false
                    },
                },
                colors: [
                    this.lfs.color
                ],
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                        barHeight: this.gs.getOptimalBarWidth(this.usage.outbound.plansUsage.labels.length) + '%',
                    }
                },
                dataLabels: {
                    total: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                            fontSize: '13px',
                            fontWeight: 900
                        }
                    }
                },
                xaxis: {
                    categories: this.usage.outbound.plansUsage.labels,
                },
            };

            const aboutToExpire = 20160; // 2 weeks in minutes
            const now = new Date();
            this.usage.general.forEach((generalObj) => {
                if ((new Date(now)).getTime() > (new Date(generalObj.expired)).getTime()) {
                    generalObj.planExpired = true;
                }
                else if (this.gs.dateDiffInMinutes((new Date()), new Date(generalObj.expired)) < aboutToExpire) {
                    generalObj.aboutToExpire = true;
                }

				generalObj.storageUsageBarOptions = this.getStorageUsageChartOptions(generalObj);

				if (generalObj.archive?.wa_enabled) {
					generalObj.archive.used_users = generalObj.inbound?.used_users > generalObj.outbound?.used_users ? generalObj.inbound?.used_users : generalObj.outbound?.used_users;
				}

				if (generalObj.threat_simulation?.enabled) {
					generalObj.threat_simulation.used_users = generalObj.inbound?.used_users || 0;
				}
            });

            this.getUsageDataInProcess = false;
        }, (err) => {
			this.getUsageDataInProcess = false;
		});
    }

	getStorageUsageChartOptions(admin) {
		// usage by category bar
		const series = [
			{name: 'Archived Emails', color: '#e0af00', data: [(admin.usage?.archive || 0) * this.dic.CONSTANTS.usageStorageMultipliers.archive * 1024]},
			{name: 'Sent Attachments', color: '#34383f', data: [(admin.usage?.attachments || 0) * this.dic.CONSTANTS.usageStorageMultipliers.attachments * 1024]},
			{name: 'Sent Emails', color: '#cb3e00', data: [(admin.usage?.emails || 0) * this.dic.CONSTANTS.usageStorageMultipliers.emails * 1024]},
			{name: 'Inbound Quarantine', color: '#8300ec', data: [(admin.usage?.quarantines || 0) * this.dic.CONSTANTS.usageStorageMultipliers.quarantines * 1024]},
		];

		const userTotalCapacityBytes = this.dic.CONSTANTS.usageStorageMultipliers.userTotalCapacity * 1024 * 1024 * 1024;
		admin.maxStorageCapacity = Math.max(admin.inbound.allowed_users, admin.outbound.allowed_users) * userTotalCapacityBytes;
		admin.totalStorageUsage = _.sum(_.map(series, value => value.data[0]));

		return {
			series: series,
			chart: {
				type: 'bar',
				height: '60',
				parentHeightOffset: 0,
				stacked: true,
				//offsetX: -25,
				//offsetY: -25,
				toolbar: {
					show: false
				}
			},
			grid: {
				show: false
			},
			plotOptions: {
				bar: {
					horizontal: true,
					barHeight: '100%',
					colors: {
						backgroundBarColors: ['#bdbdbd']
					}
				},
			},
			colors: _.map(series, 'color'),
			dataLabels: {
				enabled: false
			},
			xaxis: {
				axisBorder: {
					show: false
				},
				labels: {
					show: false
				},
				axisTicks: {
					show: false
				},
				categories: [''],
				max: (admin.totalStorageUsage / admin.maxStorageCapacity) < 0.10 ? admin.totalStorageUsage * 10 : admin.maxStorageCapacity,
				tickAmount: 1
			},
			yaxis: {
				axisBorder: {
					show: false
				},
				title: {
					text: undefined
				},
			},
			fill: {
				opacity: 1
			},
			tooltip: {
				y: {
					formatter: (val) => {
						// val is a number that represents KB. Show it as GB when possible (0.01) is the lowest format, or else in MB
						// first 'replace' is to remove unnecessary zeros after dot (XX.00). second 'replace' is to format number with commas (X,XXX)
						if (val > 1000 * 1000 * 1000 * 1000) { // from 1000GB and above - display as 1TB
							return Number(val/(1000 * 1000 * 1000 * 1000)).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' TB';
						}
						else if (val > 100 * 1000 * 1000) {  // from 100MB and above - display as 0.1GB
							return Number(val/(1000 * 1000 * 1000)).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' GB';
						}
						else { // default - display in MB
							return Number(val/(1000 * 1000)).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' MB';
						}
					}
				}
			},
			legend: {
				show: false
			}
		};
	}

    searchLicenseExpiration = (event) => {
        this.usage.general.forEach(record => {
            // search
            if (event.searchTerm) {
                const isFound = searchLicenseTextExecute(record, event.searchTerm);
                if (!isFound) {
                    record.hide = true;
                    return;
                }
            }

            record.hide = false;
        });
    }

    exportLicensesToCsv = (sortBy) => {
        if (!this.usage.general || !this.usage.general.length) {
            this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
            return;
        }

        let csvString = "Plan,Company Name,Expiration,Inbound Active Licenses,Inbound Allocated licenses,Outbound Active Licenses,Outbound Allocated licenses,Archive,Threat Simulation,Account Manager,Plan Type,Sent Emails,Sent Attachments,Inbound Quarantine,Archived Emails\n";

        let sortedTable = _.filter(this.usage.general,admin => {return !admin.hide});
        if (sortBy) {
            sortedTable = this.gs.sortTable(sortedTable, sortBy);
        }

        sortedTable.forEach((admin) => {
            if (admin.email === 'Your Plan') {
                csvString += `${admin.email},"${admin.company_name ? admin.company_name : ''}","${admin.expired}","${admin.inbound.used_users}","${this.usage.inbound.allowed_users}","${admin.outbound.used_users}","${this.usage.outbound.allowed_users}","${admin.archive?.wa_enabled ? 'Active licenses: ' + admin.archive.used_users : 'Disabled'}","${admin.threat_simulation?.enabled ? 'Active licenses: ' + admin.threat_simulation.used_users : 'Disabled'}","${admin.account_manager}","${admin.plan_sub_type_display}",${admin.usage.emails || 0},${admin.usage.attachments || 0},${admin.usage.quarantines || 0},${admin.usage.archive || 0}\n`;
            }
            else {
                csvString += `${admin.email},"${admin.company_name ? admin.company_name : ''}","${admin.expired}","${admin.inbound.used_users}","${admin.inbound.allowed_users}","${admin.outbound.used_users}","${admin.outbound.allowed_users}","${admin.archive?.wa_enabled ? 'Active licenses: ' + admin.archive.used_users : 'Disabled'}","${admin.threat_simulation?.enabled ? 'Active licenses: ' + admin.threat_simulation.used_users : 'Disabled'}","${admin.account_manager}","${admin.plan_sub_type_display}",${admin.usage.emails || 0},${admin.usage.attachments || 0},${admin.usage.quarantines || 0},${admin.usage.archive || 0}\n`;
            }
        });

        this.gs.exportCsv(csvString, `licenses_information.csv`);
    };

    showGenerateReportPopup = () => {
		this.generateReportPopup = {
			address: '',
			getPartnerInfoInProcess: true,
			actionInProcess: false,
			show: true
		};

        this.getPartnerInfo();
    }

	generatePartnersReportNow = () => {
		this.gs.showPopup({
			title: 'Generate Report',
			subTitle: 'You are about to generate a report. Once this is finished, the report will be sent to your email address.',
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Generate',
			doneCb: () => {
				this.generateReportPopup.inProcess = true;
				this.rs.createPartnerReport().then(() => {
					this.ns.showInfoMessage('Report operation started successfully');
					this.generateReportPopup.inProcess = false;
				}, (err) => {
					this.generateReportPopup.inProcess = false;
				});
			}
		});
	};

    getPartnerInfo() {
        this.rs.getPartnerInfo().then((response) => {
            this.partnerInfo = response;
			this.generateReportPopup.getPartnerInfoInProcess = false;
        }, err => {
			this.generateReportPopup.getPartnerInfoInProcess = false;
		});
    };

    updateReportSettings() {
		const data = {
			action: this.dic.CONSTANTS.reportActions.settings,
			data: this.partnerInfo.partners.scheduled_reports
		}
        this.rs.updateReportSettings(data).then((response) => {
            this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
        });
    }

	updateReportIncludeActiveLicenses() {
		const data = {
			action: this.dic.CONSTANTS.reportActions.include_active_licenses,
			data: {include_active_licenses: this.partnerInfo.partners.scheduled_reports.include_active_licenses}
		}
		this.rs.updateReportSettings(data).then((response) => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	}

	addReportAddress(address) {
		if (!address || this.generateReportPopup.actionInProcess) {
			return;
		}

		address = address.toLowerCase();
		if (this.partnerInfo.partners.scheduled_reports.report_to_emails.find(itm => itm === address)) {
			this.ns.showErrorMessage(util.format(this.dic.ERRORS.itemAlreadyExist, address));
			return;
		}

		this.generateReportPopup.actionInProcess = true;

		const actionInfo = {
			action: this.dic.CONSTANTS.reportActions.emails,
			data: {
				email: address,
				type: this.dic.CONSTANTS.actions.add
			}
		}
		this.rs.updateReportSettings(actionInfo).then(() => {
			this.partnerInfo.partners.scheduled_reports.report_to_emails.push(address);
			this.generateReportPopup.address = '';
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			this.generateReportPopup.actionInProcess = false;
		}, err => {
			this.generateReportPopup.actionInProcess = false;
		});
	}

	deleteReportAddress(address) {
		if (!address || this.generateReportPopup.actionInProcess) {
			return;
		}

		address = address.toLowerCase();
		if (!this.partnerInfo.partners.scheduled_reports.report_to_emails.find(itm => itm === address)) {
			return;
		}

		this.generateReportPopup.actionInProcess = true;

		const actionInfo = {
			action: this.dic.CONSTANTS.reportActions.emails,
			data: {
				email: address,
				type: this.dic.CONSTANTS.actions.delete
			}
		}
		this.rs.updateReportSettings(actionInfo).then(() => {
			this.partnerInfo.partners.scheduled_reports.report_to_emails.splice(_.indexOf(this.partnerInfo.partners.scheduled_reports.report_to_emails, address), 1);
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			this.generateReportPopup.actionInProcess = false;
		}, err => {
			this.generateReportPopup.actionInProcess = false;
		});
	}

	showPartnerActions = (partner) => {
		return ['Modify Plan'];
	}

	selectPartnerAction = (userObj, action) => {
		switch (action) {
			case 'Modify Plan':
				this.updateAdminPlan(userObj);
				break;
		}
	};

	updateAdminPlan = (sharedUser) => {
		this.curSharedUser = sharedUser || {};
		this.curSharedUser.invoiceNotify = null;
		this.curSharedUser.errMsg = '';
		this.curSharedUser.isExtendExpirationMenuOpen = false;
		this.curSharedUser.extendExpirationMethod = '';
		this.curSharedUser.newExpirationDate = null;

		this.currentAdminObj = this.usage.general.find(itm => itm.email === 'Your Plan');

		this.curSharedUser.allowedUsers = this.curSharedUser.shared_plan.allowed_users || 1;
		this.curSharedUser.allowedLicenses = this.curSharedUser.threat_protection.allowed_users || 0;
		this.curSharedUser.planSubType = this.curSharedUser.plan_sub_type;
		this.curSharedUser.customerId = this.curSharedUser.customer_id;
		if (this.curSharedUser.customer_id) {
			this.curSharedUser.setAsPartner = true;
		}

		this.curSharedUser.companyName = this.curSharedUser.company_name;
		this.userManagementLoaded = true;
		this.updateAdminPlanPopup = true;


		this.initExpirationDate();
		this.prepareInvoiceNotifyMessage();
	};

	updateExpirationTime = (expandMethod) => {
		this.curSharedUser.extendExpirationMethod = expandMethod;
		const currentDate = new Date(this.curSharedUser.adminExpirationDate);

		switch (expandMethod) {
			case this.expandMethods.oneMonth.value:
				this.curSharedUser.newExpirationDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
				break;

			case this.expandMethods.oneYear.value:
				this.curSharedUser.newExpirationDate = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));
				break;

			case this.expandMethods.twoYears.value:
				this.curSharedUser.newExpirationDate = new Date(currentDate.setFullYear(currentDate.getFullYear() + 2));
				break;

			case this.expandMethods.threeYears.value:
				this.curSharedUser.newExpirationDate = new Date(currentDate.setFullYear(currentDate.getFullYear() + 3));
				break;
		}
	}

	setMspAnnualAdminValues = (planSubType) => {
		this.curSharedUser.planSubType = planSubType;
	};

	initExpirationDate = () => {
		if (this.curSharedUser && this.curSharedUser && this.curSharedUser.expired) {
			this.curSharedUser.adminExpirationDate = this.curSharedUser.expired;
		}

		this.curSharedUser.adminExpirationDateString = this.formatDateString(this.curSharedUser.adminExpirationDate);

		if (new Date(this.curSharedUser.adminExpirationDate) < new Date()) {
			this.curSharedUser.showOldExpirationDate = true;
		}
	};

	formatDateString = (date) => {
		if (!date) {
			return
		}

		let formatDate = new Date(date);
		let formatMonth:any = formatDate.getMonth() + 1;
		let formatDay:any = formatDate.getDate();
		let formatYear = formatDate.getFullYear();

		if (formatMonth < 10) {
			formatMonth = "0" + formatMonth;
		}
		if (formatDay < 10) {
			formatDay = "0" + formatDay;
		}
		return String(formatMonth + "/" + formatDay + "/" + formatYear)
	};

	prepareInvoiceNotifyMessage = () => {
		if (!this.currentAdminObj.partners || !this.currentAdminObj.partners.automatic_invoice) {
			this.curSharedUser.invoiceNotify = null;
			return;
		}
		if (this.curSharedUser.planSubType === this.dic.CONSTANTS.planSubType.poc) {
			this.curSharedUser.invoiceNotify = null;
			return;
		}

		if (this.curSharedUser.planSubType === this.dic.CONSTANTS.planSubType.msp) {
			this.curSharedUser.invoiceNotify = 'An invoice for the allocated Monthly plan will be sent at the start of next month';
			return;
		}

		if (this.curSharedUser.extendExpirationMethod) {
			this.extendExpirationDate(this.curSharedUser.extendExpirationMethod);
			return;
		}

		if (this.addActiveAdminPopup) {
			return this.allocatePlanPartnerInvoiceMessage();
		}

		this.addMoreUsersPartnerInvoiceMessage();
	}

	extendExpirationDate = (expandMethod) => {
		const licenses = this.Math.max(this.curSharedUser.allowedUsers, this.curSharedUser.allowedLicenses);

		this.curSharedUser.extendExpirationMethod = expandMethod;
		switch (expandMethod) {
			case this.expandMethods.oneMonth.value:
				this.curSharedUser.invoiceNotify = `Extending plan expiration date by a month, for <b>${licenses}</b> licenses, will cost an additional <b>$${(licenses * this.currentAdminObj.partners.license_price.monthly).toFixed(2)}</b>.`;
				break;

			case this.expandMethods.oneYear.value:
				this.curSharedUser.invoiceNotify = `Extending plan expiration date by a year, for <b>${licenses}</b> licenses, will cost an additional <b>$${(licenses * this.currentAdminObj.partners.license_price.yearly).toFixed(2)}</b>.`;
				break;

			case this.expandMethods.twoYears.value:
				this.curSharedUser.invoiceNotify = `Extending plan expiration date by 2 years, for <b>${licenses}</b> licenses, will cost an additional <b>$${(licenses * 2 * 0.9 * this.currentAdminObj.partners.license_price.yearly).toFixed(2)}</b>.`;
				break;

			case this.expandMethods.threeYears.value:
				this.curSharedUser.invoiceNotify = `Extending plan expiration date by 3 years, for <b>${licenses}</b> licenses, will cost an additional <b>$${(licenses * 3 * 0.8 * this.currentAdminObj.partners.license_price.yearly).toFixed(2)}</b>.`;
				break;
		}
	}

	allocatePlanPartnerInvoiceMessage = () => {
		const newLicenses = Math.max(this.curSharedUser.allowedUsers || 0, this.curSharedUser.allowedLicenses || 0);
		if (!newLicenses) {
			this.curSharedUser.invoiceNotify = null;
			return;
		}

		// @ts-ignore
		const monthsLeftUntilExpiration = (Math.max(0, Math.ceil((new Date(this.curSharedUser.adminExpirationDate) - new Date()) / (30 * 24 * 60 * 60 * 1000))) || 1);
		const unitPrice = monthsLeftUntilExpiration <= 12 ? this.currentAdminObj.partners.license_price.monthly * monthsLeftUntilExpiration : monthsLeftUntilExpiration <= 24 ?
			this.currentAdminObj.partners.license_price.monthly * monthsLeftUntilExpiration * 0.9 : this.currentAdminObj.partners.license_price.monthly * monthsLeftUntilExpiration * 0.8;

		this.curSharedUser.invoiceNotify = `Allocate a plan with ${newLicenses} licenses will cost $${newLicenses * unitPrice}`;
	}

	addMoreUsersPartnerInvoiceMessage = () => {
		// modify plan
		const currentLicenses = Math.max(this.curSharedUser.shared_plan.allowed_users, this.curSharedUser.threat_protection.allowed_users);
		const newLicenses = Math.max(this.curSharedUser.allowedUsers || 0, this.curSharedUser.allowedLicenses || 0);
		if (newLicenses <= currentLicenses) {
			this.curSharedUser.invoiceNotify = null;
			return;
		}

		const addUsers = newLicenses - currentLicenses;

		// @ts-ignore
		const monthsLeftUntilExpiration = Math.max(0, Math.ceil((new Date(this.curSharedUser.expired) - new Date()) / (30 * 24 * 60 * 60 * 1000)));

		if (!monthsLeftUntilExpiration) {
			// means that the plan was expired
			return;
		}

		const unitPrice = monthsLeftUntilExpiration <= 12 ? this.currentAdminObj.partners.license_price.monthly * monthsLeftUntilExpiration : monthsLeftUntilExpiration <= 24 ?
			this.currentAdminObj.partners.license_price.monthly * monthsLeftUntilExpiration * 0.9 : this.currentAdminObj.partners.license_price.monthly * monthsLeftUntilExpiration * 0.8;

		this.curSharedUser.invoiceNotify = `Adding these licenses will cost an additional $${addUsers * unitPrice}`;
	}

	cancelExtendExpirationDate = () => {
		this.curSharedUser.extendExpirationMethod = null;
		this.curSharedUser.newExpirationDate = null;
		this.curSharedUser.invoiceNotify = null;

		this.prepareInvoiceNotifyMessage();
	}

	changePlanSubType = (subType) => {
		this.curSharedUser.planSubType = subType;
		switch (this.curSharedUser.planSubType) {
			case this.dic.CONSTANTS.planSubType.annual:
				this.clearPlanAnnual();
				break;

			case this.dic.CONSTANTS.planSubType.poc:
				this.setExpirationDateForPoc();
				break;

			case this.dic.CONSTANTS.planSubType.msp:
				this.clearPlanMsp();
				break;
		}

		this.prepareInvoiceNotifyMessage();
	};

	clearPlanAnnual = () => {
		this.setMspAnnualAdminValues(this.dic.CONSTANTS.planSubType.annual);

		if (this.curSharedUser && this.curSharedUser.expired) {
			this.curSharedUser.adminExpirationDate = new Date(this.curSharedUser.expired);
		}
		else {
			this.curSharedUser.adminExpirationDate = new Date();
		}
		this.updateExpirationTime(this.curSharedUser.extendExpirationMethod);
	};

	clearPlanMsp = () => {
		this.setMspAnnualAdminValues(this.dic.CONSTANTS.planSubType.msp);
		this.setExpirationDateForMsp();
	};

	closeAllocateModifyPopup = () => {
		this.updateAdminPlanPopup = false;

		this.curSharedUser = null;
	};

	setExpirationDateForMsp = () => {
		const date = new Date();
		const mspDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
		if (this.curSharedUser.adminExpirationDate === this.formatDateString(mspDate)) {
			return;
		}
		this.curSharedUser.adminExpirationDate = mspDate;
		this.curSharedUser.adminExpirationDateString = this.formatDateString(this.curSharedUser.adminExpirationDate);
	};

	setExpirationDateForPoc = () => {
		const date = new Date();
		let pocDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 14);
		pocDate = _.min([pocDate, this.getMainAdminExpirationDate()]);
		if (this.curSharedUser.adminExpirationDate === this.formatDateString(pocDate)) {
			return;
		}
		this.curSharedUser.adminExpirationDate = pocDate;
		this.curSharedUser.adminExpirationDateString = this.formatDateString(this.curSharedUser.adminExpirationDate);
	};

	getMainAdminExpirationDate = () => {
		return new Date(this.currentAdminObj.expired);
	}

	isUpdateDisabled = () => {
		if (this.curSharedUser.planManagedBy === this.dic.CONSTANTS.planManagedBy.admin && !this.curSharedUser.email) {
			return true;
		}
		if (this.curSharedUser.planManagedBy === this.dic.CONSTANTS.planManagedBy.you && !this.curSharedUser.domain) {
			return true;
		}
		return false;
	};

	updateAdminPlanExecute = () => {
		if (!this.curSharedUser.adminExpirationDate) {
			this.curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoExpiration;
			return;
		}
		if (!this.curSharedUser.allowedUsers) {
			this.curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoUsers;
			return;
		}

		if (typeof this.curSharedUser.allowedLicenses !== 'number' || this.curSharedUser.allowedLicenses < 0) {
			this.curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoInboundLicenses;
			return;
		}

		if (this.curSharedUser.setAsPartner && !this.curSharedUser.customerId) {
			this.curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoPartnerId;
			return;
		}

		if (!this.curSharedUser.setAsPartner) {
			this.curSharedUser.customerId = '';
		}

		const userDomain = this.gs.getDomain(this.curSharedUser.email);
		this.curSharedUser.errMsg = '';
		this.setUserAsAdminInProcess = true;
		const expirationDate = this.getPlanExpirationDate(this.curSharedUser.adminExpirationDate, this.curSharedUser.extendExpirationMethod);

		const actionInfo = {
			action: this.dic.CONSTANTS.planAdminActions.modifyPlan,
			parent: this.currentAdminObj.user_id.email,
			plan: {
				planSubType: this.curSharedUser.planSubType,
				users: this.curSharedUser.allowedUsers,
				inboundLicenses: this.curSharedUser.allowedLicenses,
				expired: expirationDate,
				customerId: this.curSharedUser.customerId,
				company_name: this.curSharedUser.companyName || this.curSharedUser.customerId || userDomain,
				archive: this.curSharedUser.archive.wa_enabled,
				threat_simulation: this.curSharedUser.threat_simulation.enabled,
				allow_support_wa: this.curSharedUser.allow_support_wa,
				hide_partner_access: this.curSharedUser.hide_partner_access,
				extendExpiration: this.curSharedUser.extendExpirationMethod
			}
		};

		this.rs.doActionOnPlanAdmin(this.curSharedUser.email, actionInfo).then(() => {
			this.setUserAsAdminInProcess = false;
			this.updateAdminPlanPopup = false;

			const currentAdminObj = this.usage.general.find(itm => itm.email === 'Your Plan');

			currentAdminObj.shared_plan.used_users = currentAdminObj.shared_plan.used_users + this.curSharedUser.allowedUsers - this.curSharedUser.shared_plan.allowed_users;
			currentAdminObj.threat_protection.used_users = currentAdminObj.threat_protection.used_users + this.curSharedUser.allowedLicenses - this.curSharedUser.threat_protection.allowed_users;

			this.curSharedUser.shared_plan.allowed_users = this.curSharedUser.allowedUsers;
			this.curSharedUser.threat_protection.allowed_users = this.curSharedUser.allowedLicenses;
			this.curSharedUser.plan_sub_type = this.curSharedUser.planSubType;
			this.curSharedUser.expired = expirationDate;
			this.curSharedUser.customer_id = this.curSharedUser.customerId;
			this.curSharedUser.company_name = this.curSharedUser.companyName || this.curSharedUser.customerId || userDomain;
			this.curSharedUser.customer_id = this.curSharedUser.customerId;
			this.curSharedUser.outbound.allowed_users = this.curSharedUser.allowedUsers;
			this.curSharedUser.inbound.allowed_users = this.curSharedUser.allowedLicenses;
			if (this.curSharedUser.threat_simulation.enabled) {
				this.curSharedUser.threat_simulation.used_users = this.curSharedUser.inbound?.used_users || 0;
			}
			if (this.curSharedUser.archive.wa_enabled) {
				this.curSharedUser.archive.used_users = this.curSharedUser.inbound?.used_users > this.curSharedUser.outbound?.used_users ? this.curSharedUser.inbound?.used_users : this.curSharedUser.outbound?.used_users;
			}
			this.changePlanSubTypeDisplay(this.curSharedUser);
			this.gs.filterPlansWithNoPartnerAccess(this.curSharedUser.email, this.curSharedUser.hide_partner_access);
		}, (err) => {
			if (err && err.data && err.data.message) {
				this.curSharedUser.errMsg = err.data.message;
			}
			this.setUserAsAdminInProcess = false;
		});
	};

	getPlanExpirationDate(planExpirationDate, extendExpirationMethod) {
		let expirationDate = new Date(planExpirationDate).toISOString();
		if (extendExpirationMethod && this.curSharedUser.planSubType === this.dic.CONSTANTS.planSubType.annual) {
			const myDate = new Date(planExpirationDate);

			switch (extendExpirationMethod) {
				case this.expandMethods.threeYears.value:
					expirationDate = new Date(myDate.setDate(myDate.getDate() + 365 * 3)).toISOString();
					break;

				case this.expandMethods.twoYears.value:
					expirationDate = new Date(myDate.setDate(myDate.getDate() + 365 * 2)).toISOString();
					break;

				case this.expandMethods.oneYear.value:
					expirationDate = new Date(myDate.setDate(myDate.getDate() + 365)).toISOString();
					break;

				case this.expandMethods.oneMonth.value:
					expirationDate = new Date(myDate.setMonth(myDate.getMonth() + 1)).toISOString();
					break;
			}
		}

		return expirationDate;
	}

	changePlanSubTypeDisplay = (generalObj) => {
		switch (generalObj.plan_sub_type) {
			case this.dic.CONSTANTS.planSubType.annual:
				generalObj.plan_sub_type_display = 'Pro';
				break;

			case this.dic.CONSTANTS.planSubType.poc:
				generalObj.plan_sub_type_display = 'PoC'
				break;

			case this.dic.CONSTANTS.planSubType.msp:
				generalObj.plan_sub_type_display = 'Monthly';
				break;
		}
	}
}

function searchLicenseTextExecute(license, searchTerm) {
    searchTerm = searchTerm.toLowerCase();
    return ((license.email.toLowerCase().indexOf(searchTerm) > -1) ||
            (license.company_name?.toLowerCase().indexOf(searchTerm) > -1));
}
